export default __webpack_public_path__ + "static/media/Stay Calm.fff2b453.png";